import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";
import Input from './text/input'
import Table from './text/table'

function Text (props) {

    const emptySpace = "___",
        topLoci = props.topLoci,
        chr = props.chr,
        pos = props.pos,
        refV = props.refV,
        altV = props.altV,
        settings = props.settings,
        setLocus = props.setLocus,
        setSlot = props.setSlot,
        format = props.format,
        extra = props.extra,
        getExtra = props.getExtra;

    useEffect (()=>{
        d3.select('#text').selectAll('.section').transition().duration(500).style('opacity',1);
    })

    return (
        <div id="text">
            <Input 
                emptySpace={emptySpace}
                setLocus={setLocus}
                setSlot={setSlot}
            />
            <Table 
                emptySpace={emptySpace}
                topLoci={topLoci}
                chr={chr}
                pos={pos}
                refV={refV}
                altV={altV}
                settings={settings}
                setLocus={setLocus}
                setSlot={setSlot}
                format={format}
                extra={extra}
                getExtra={getExtra}
            />
        </div>
    )
}
export default Text;